export default __webpack_public_path__ + "static/media/csharp.e67b7796.svg";